import React from 'react';
export function BurningFacebookBg() {
  return <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{
    zIndex: 0,
    contain: 'strict'
  }} aria-hidden="true" data-id="element-550">
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-551">
        {/* Smaller on mobile (300px), full on desktop (600px) */}
        <div className="relative w-[300px] h-[300px] md:w-[600px] md:h-[600px]" data-id="element-552">
          {/* The logo itself */}
          <svg viewBox="0 0 512 512" className="absolute inset-0 w-full h-full" style={{
          opacity: 0.035
        }} data-id="element-553">
            <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" fill="#FF6B00" data-id="element-554" />
          </svg>

          {/* Flame glow — static on mobile, animated on desktop */}
          <div className="absolute inset-0 animate-flame-glow" style={{
          background: 'radial-gradient(ellipse at 50% 65%, rgba(255,107,0,0.06) 0%, rgba(251,191,36,0.03) 35%, rgba(220,38,38,0.02) 55%, transparent 75%)'
        }} data-id="element-555" />

          {/* Flame flicker — hidden on mobile for performance */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 animate-flame-flicker hidden md:block" style={{
          width: '60%',
          height: '75%',
          background: 'linear-gradient(to top, rgba(255,107,0,0.05) 0%, rgba(251,191,36,0.03) 35%, rgba(220,38,38,0.015) 60%, transparent 100%)',
          filter: 'blur(25px)',
          transformOrigin: 'bottom center'
        }} data-id="element-556" />
        </div>
      </div>
    </div>;
}